import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { getAssetLink } from '../../../helpers/get-asset-link'

const RederPdfModal = ({ closeModal, isOpen, file }) => {
  const { t } = useTranslation(['client-reservations'])
  return (
    <div className={`modal modal--organisation ${isOpen ? 'is-active' : ''}`}>
      <div className="modal-background" onClick={() => closeModal()} />
      <div className="modal-content" style={{ width: '800px' }}>
        <div className="box">
          <header className="modal__header">
            {<span>{t('client-reservations:readerModal.title')}</span>}
            <button
              className="modal-close is-large"
              aria-label="close"
              onClick={() => closeModal()}
              style={{ marginRight: '10px' }}
            />
          </header>
          <div className="modal__inner ctp-popup-list">
            <section className="ctp-package vcentered autoheight">
              <object
                data={
                  file && file.includes('data:application/pdf;')
                    ? file
                    : getAssetLink({ path: 'chitown-building', file: file })
                }
                type="application/pdf"
                width="600"
                height="700"
              />
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}

RederPdfModal.propTypes = {
  file: PropTypes.string,
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
}

export default RederPdfModal
